import { render, staticRenderFns } from "./StudentForm.vue?vue&type=template&id=07995b8c&scoped=true&"
import script from "./StudentForm.vue?vue&type=script&lang=ts&"
export * from "./StudentForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudentForm.vue?vue&type=style&index=0&id=07995b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07995b8c",
  null
  
)

export default component.exports